module.exports = __webpack_public_path__ + "media/site_templates/www.polishingfloorboards.com.au/images/testimonials-a064e9de90edc54c314ac0f569617cdc.jpg";